import { avatarColor, initialsOf } from "../theme";

/** Initials on a colour picked by the name (the app's `Avatar`). */
export default function Avatar({
  name,
  size = 40,
  color,
  className,
  dim,
}: {
  name: string | null | undefined;
  size?: number;
  color?: string;
  className?: string;
  dim?: boolean;
}) {
  const label = name?.trim() || "?";
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold text-white ${className ?? ""}`}
      style={{ width: size, height: size, backgroundColor: color ?? avatarColor(label), fontSize: Math.round(size * 0.36), opacity: dim ? 0.45 : 1 }}
      aria-hidden
    >
      {initialsOf(label) || "?"}
    </span>
  );
}
